import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "closeIcon",
  "use": "closeIcon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"closeIcon\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path data-name=\"↳color\" d=\"M13.769 11.999l7.865-7.865a1.251 1.251 0 0 0-1.769-1.768L12 10.232 4.135 2.366a1.251 1.251 0 1 0-1.769 1.769l7.866 7.864-7.866 7.866a1.25 1.25 0 1 0 1.769 1.768L12 13.768l7.865 7.865a1.251 1.251 0 0 0 1.769-1.769z\" fill=\"#031425\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol